import { relativeFromNow } from '@/components/webs/email-blasts/engagementFormat'
import type { EmailActivityRowDto } from '@/types/emailActivity'

// The row's "When" column: the schedule while queued, else the dispatch time, else creation — as a short
// relative label ("2d ago" / "in …" via the shared formatter).
export function whenLabel(row: EmailActivityRowDto): string {
    const instant = row.Status === 'Scheduled'
        ? row.ScheduledSendAtUtc
        : row.SentAtUtc ?? row.CreatedDate
    return relativeFromNow(instant)
}

/** A step in a send's status timeline (rendered by the detail flyout). */
export interface EmailMilestone {
    label: string
    at?: string | null
    note?: string | null
    tone?: 'primary' | 'danger'
}

// The send's status timeline, built from whichever milestone timestamps are present on the row. Clicks are
// privileged (primary tone); a bounce/failure carries its reason with a danger tone.
export function buildEmailMilestones(row: EmailActivityRowDto): EmailMilestone[] {
    const milestones: EmailMilestone[] = []
    if (row.ScheduledSendAtUtc) milestones.push({ label: 'Scheduled', at: row.ScheduledSendAtUtc })
    if (row.SentAtUtc) milestones.push({ label: 'Sent', at: row.SentAtUtc })
    if (row.DeliveredAtUtc) milestones.push({ label: 'Delivered', at: row.DeliveredAtUtc })
    if (row.FirstOpenedAtUtc) milestones.push({ label: 'Opened', at: row.FirstOpenedAtUtc, note: row.OpenCount > 1 ? `×${row.OpenCount}` : null })
    if (row.FirstClickedAtUtc) milestones.push({ label: 'Clicked', at: row.FirstClickedAtUtc, note: row.LastClickedUrl, tone: 'primary' })
    if (row.BouncedAtUtc) milestones.push({ label: 'Bounced', at: row.BouncedAtUtc, note: row.FailureReason, tone: 'danger' })
    if (row.Status === 'Failed' && row.FailureReason) milestones.push({ label: 'Failed', note: row.FailureReason, tone: 'danger' })
    return milestones
}
